import { PromotionDeduction } from "@/core/entities/promotion/PromotionDeduction";
import { atom } from "jotai";
import { AppConfig } from "@/infrastructure/services/config";

const _AppConfig = AppConfig.getInstance();
const PAGINATION_PAGE_LIMIT = _AppConfig.PAGINATION_PAGE_LIMIT;

export interface PromotionAppliedDeductionsState {
  items: PromotionDeduction[];
  totalDeductionsClaimed: number;
  totalDeductionsAmount: number;
  count: number;
  hasFetched: boolean;
  isLoading: boolean;
  isRefreshing: boolean;
  error: Error | null;
  currentPage: number;
  pageLimit: number;
}

const initialState: PromotionAppliedDeductionsState = {
  items: [],
  totalDeductionsClaimed: 0,
  totalDeductionsAmount: 0,
  count: 0,
  hasFetched: false,
  isLoading: false,
  isRefreshing: false,
  error: null,
  currentPage: 1,
  pageLimit: PAGINATION_PAGE_LIMIT,
};

export const promotionAppliedDeductionsAtom = atom<PromotionAppliedDeductionsState>(initialState);

export const promotionAppliedDeductionsCurrentPageAtom = atom(
  get => get(promotionAppliedDeductionsAtom).currentPage
);
export const promotionAppliedDeductionsPageLimitAtom = atom(get => get(promotionAppliedDeductionsAtom).pageLimit);
export const promotionAppliedDeductionsListAtom = atom(get => get(promotionAppliedDeductionsAtom).items);
export const promotionAppliedDeductionsIsLoadingAtom = atom(get => get(promotionAppliedDeductionsAtom).isLoading);
export const promotionAppliedDeductionsIsRefreshingAtom = atom(
  get => get(promotionAppliedDeductionsAtom).isRefreshing
);
export const promotionAppliedDeductionsErrorAtom = atom(get => get(promotionAppliedDeductionsAtom).error);
export const promotionAppliedDeductionsCountAtom = atom(get => get(promotionAppliedDeductionsAtom).count);
export const promotionAppliedDeductionsHasFetchedAtom = atom(get => get(promotionAppliedDeductionsAtom).hasFetched);
export const promotionAppliedDeductionsTotalClaimedAtom = atom(
  get => get(promotionAppliedDeductionsAtom).totalDeductionsClaimed
);
export const promotionAppliedDeductionsTotalAmountAtom = atom(
  get => get(promotionAppliedDeductionsAtom).totalDeductionsAmount
);

export const resetPromotionAppliedDeductionsAtom = atom(null, (_get, set) => {
  set(promotionAppliedDeductionsAtom, initialState);
});
